import Box from "@mui/material/Box";

// import AppsNavigation from "./Navigation/Apps";
import FaceNavigation from "./Navigation/Face";

export default function Navigation() {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        left: 20,
        padding: 2,
        border: "2px solid #333",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        borderRadius: 1,
        fontFamily: '"IBM Plex Mono", "Courier New", monospace',
        color: "#000",
        zIndex: 1000,
        backdropFilter: "blur(10px)",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <FaceNavigation></FaceNavigation>
    </Box>
  );
}

export { Navigation };
